import { useContext } from 'react'
import IndexPageContext, { IndexPageContextType } from './Context'

const EMPTY_CONTEXT: IndexPageContextType = {
  model: null,
  resourceId: null,
  resource: null,
  action: null,
}

const useIndexPageContext = () => useContext(IndexPageContext) || EMPTY_CONTEXT

export default useIndexPageContext
